import { Magic } from "magic-sdk";
import config from "../../configs";
import { OAuthExtension } from "@magic-ext/oauth";

declare let window: any;

export class BaseMagiclinkService {
  public magic?: Magic;
  public magicSocial?: any;

  constructor() {
    this.magic =
      typeof window !== "undefined"
        ? new Magic(config.magiclinkKey)
        : undefined;

    this.magicSocial =
      typeof window !== "undefined"
        ? new Magic(config.magiclinkKey, {
            extensions: [new OAuthExtension()],
          })
        : undefined;
  }
}
